import React, { useState } from 'react';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import isBrowser from '~/utils/is-browser';
import ga from '~/utils/ga';

export const useMission2 = (mission1Count, updateAbleMisssionState, isValidAuth, openModal) => {

  const sessionAuthKey = isBrowser() && sessionStorage.getItem('authKey');

  const [ checkMission2Condition, setMission2Condition ] = useState({
    myAddress: '',
    selectedResult: [],
    hasOtherReason: '',
  })

  //우리 동네 찾기
  const selectMyAddress = value => {
    setMission2Condition(prev=> ({...prev, myAddress: value?.fullName}));
  }

  //살기좋은 3가지 이상 고른다.
  const onClickItem = (clickedItem) => {
    if (!isValidAuth()) return;
    
    if (mission1Count === 0) {
      alert('첫번째 미션을 완료한 분들께 드리는 혜택입니다.첫 번째 미션을 먼저 완료해 주세요!');
      return;
    }

    if (checkMission2Condition.selectedResult?.includes(clickedItem)) {
      const result = checkMission2Condition.selectedResult?.filter(code => code !== clickedItem);
      setMission2Condition(prev => ({...prev, selectedResult: result}))

    } else {
      setMission2Condition(prev => ({...prev, selectedResult: [...prev.selectedResult, clickedItem]}))
    }
  }

  const onFocusHandler = (e) => {
    if (!isValidAuth()) {
      e.target.blur();
      return;
    }
    
    if (mission1Count === 0) {
      alert('첫번째 미션을 완료한 분들께 드리는 혜택입니다.첫 번째 미션을 먼저 완료해 주세요!');
      e.target.blur();
      return;
    }
  }

  const onChangeOtherReason = (e) => {
    const { value } = e.target;
    setMission2Condition(prev => ({...prev, hasOtherReason: value}));
  }

  const isValidateMission2 = () => {
    if (!isValidAuth()) return false;
    
    if (mission1Count === 0) {
      alert('첫번째 미션을 완료한 분들께 드리는 혜택입니다.첫 번째 미션을 먼저 완료해 주세요!');
      return false;
    }

    if (!checkMission2Condition.myAddress) {
      alert('동네를 등록해 주세요!')
      return false;
    }

    if (checkMission2Condition.selectedResult.length < 3) {
      alert('우리 동네가 좋은 이유를 3가지 이상 선택해 주세요.')
      return false;
    }
    
    return true;
  }

  const submitMission2 = async (ableMission2) => {
    //미션2제출하기버튼상태일때
    if (ableMission2 !== true) {
      if (isValidateMission2()) {
        const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL;
        
        const temp = {
          authKey: sessionAuthKey,
          name: checkMission2Condition.myAddress,
          reason: checkMission2Condition.selectedResult?.toString(),
          comment: checkMission2Condition.hasOtherReason,
        };

        try {
          const { code } = await apiCall.post(`${host}/api/v1/event/2023/dabang/tvc/mission2`, temp);

          if( code === 200 ){
            updateAbleMisssionState({
              ableMission2: true,
            })
            openModal()
          }

          ga('23-03_TVC', '미션 제출하기', '미션2 제출하기');

        } catch(error) {
          const errorMessage = error.message || '네트워크 문제가 생겼습니다.';
          console.log(error)
          alert(errorMessage)
        }
      }

      //미션2완료 버튼상태일때
    } else {
      return;
    }
  }

  return {
    checkMission2Condition,
    onClickItem,
    selectMyAddress,
    onChangeOtherReason,
    onFocusHandler,
    submitMission2,
  }
};
